import { useEffect, useState, type Dispatch, type SetStateAction } from "react";
import { PageTabs } from "../component/list/PageTabs";

// ui
import {
  Box,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
  Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

// Table
import TableTopBar from "../component/TableTopBar";
import { ConstTable } from "../component/Table";

// Bar
import { SerchSideBar } from "../component/SerchSideBar";

// Modal
import { DataDetailTable } from "../component/detail/DataDetailTable";
import { DataEditModal } from "../component/DataEditModal";
import { DataAddModal } from "../component/DataAddModal";
import { DataAddModalResult } from "../component/DataAddModalResult";
import { PostCSVModal } from "../component/PostCSVModal";
import { ProductEditModal } from "../component/ProductEditModal";
import { DataDeleteModal } from "../component/tableFunction/DataDeleteModal";
import { FormOptionsEditModal } from "../component/tableFunction/FormOptionsEditModal";
import { DeletePaymentModal } from "../component/tableFunction/DeletePaymentModal";

// jotai
import { useAtomValue, useSetAtom } from "jotai";
import { AppAtoms } from "../lib/store";

// API
import {
  getOutsideEntryForms,
  getOutsideEntryForm,
  putOutsideEntryForm,
  postOutsideEntryForm,
  deleteOutsideEntryForm,
  postOutsideEntryFormOptions,
  deleteOutsideEntryFormOptions,
  getOutsideEntryFormDeleteOptionNames,
} from "../api/outsideEntryForm";
import {
  getOutsideEntryFormGroups,
  postOutsideEntryFormGroups,
} from "../api/outsideEntryFormGroup";
import {
  getOutsideEntryFormSMSs,
  getOutsideEntryFormSMS,
  putOutsideEntryFormSMS,
  postOutsideEntryFormSMS,
  deleteOutsideEntryFormSMS,
} from "../api/outsideEntryFormSMS";
import {
  getOutsideEntryFormCancellSMSs,
  getOutsideEntryFormCancellSMS,
  putOutsideEntryFormCancellSMS,
  postOutsideEntryFormCancellSMS,
  deleteOutsideEntryFormCancellSMS,
} from "../api/outsideEntryFormCancellSMS";
import {
  getOutsideEntryFormServices,
  getOutsideEntryFormService,
  putOutsideEntryFormService,
  postOutsideEntryFormService,
  deleteOutsideEntryFormService,
} from "../api/outsideEntryFormService";
import {
  getOutsideEntryFormServiceInsideServices,
  postOutsideEntryFormServiceInsideServices,
} from "../api/outsideEntryFormServiceInsideService";
import {
  getOutsideEntryFormOptions,
  putOutsideEntryFormOptions,
  getOutsideEntryFormOption,
  getOutsideEntryFormOptionsDependServices,
} from "../api/outsideEntryFormOption";
import { getOutsideEntryFormOptionSelects } from "../api/outsideEntryFormOptionSelect";
import { getOutsideEntryFormOptionDependServices } from "../api/outsideEntryFormOptionDependService";
import { getOutsideEntryFormOptionDependSelects } from "../api/outsideEntryFormOptionDependSelect";
import {
  getOutsideEntryFormChatApps,
  getOutsideEntryFormChatApp,
  putOutsideEntryFormChatApp,
  postOutsideEntryFormChatApp,
  deleteOutsideEntryFormChatApp,
} from "../api/outsideEntryFormChatApp";
import {
  getOutsideEntryFormChatAppDependSelects,
  postOutsideEntryFormChatAppDependSelect,
  deleteOutsideEntryFormChatAppDependSelect,
  getOutsideEntryFormOptionsForChatAppDepend,
} from "../api/outsideEntryFormChatAppDependSelect";
import { getPresignedPostCSV, postPresignedPost } from "../api/presignedURL";
import {
  getSerchHighRankCompanys,
  getSerchCategorys,
  getSerchProducts,
  getSerchSaleCompanys,
  getSerchSitePaths,
} from "../api/serch";

// InterFace
import { outsideEntryFormTableColumn } from "../config/outsideEntryForm";
import {
  dataDifine,
  subDataDifine,
  EditDataDifine,
} from "../config/dataInterface";

// OtherFunc
import { getFirstYear, getOneYear } from "../lib/other";
import { CONST, LIST_POST } from "../config/const";

const postCSVColumnOutsideEntryFormOption: { name: string; required: boolean }[] = [
  { name: "サイトパス", required: true },
  { name: "エントリーパートナー", required: true },
  { name: "グループの指定", required: true },
  { name: "グループ1", required: true },
  { name: "グループ2", required: true },
  { name: "グループ3", required: true },
  { name: "グループ4", required: true },
  { name: "グループ5", required: true },
  { name: "質問名", required: true },
  { name: "外部ETフォームでの表示", required: true },
  { name: "チャットアプリ連携", required: true },
  { name: "必須フラグ", required: true },
  { name: "質問区分", required: true },
  { name: "デフォルト値", required: true },
  { name: "入力値の編集", required: true },
  { name: "説明", required: true },
  { name: "フラグ設定", required: true },
  { name: "依存外部サービス名1", required: true },
  { name: "依存外部サービス名2", required: true },
  { name: "依存外部サービス名3", required: true },
  { name: "依存外部サービス名4", required: true },
  { name: "依存外部サービス名5", required: true },
  { name: "依存質問名", required: true },
  { name: "依存選択肢1", required: true },
  { name: "依存選択肢2", required: true },
  { name: "依存選択肢3", required: true },
  { name: "依存選択肢4", required: true },
  { name: "依存選択肢5", required: true },
  { name: "選択肢1", required: true },
  { name: "選択肢2", required: true },
  { name: "選択肢3", required: true },
  { name: "選択肢4", required: true },
  { name: "選択肢5", required: true },
  { name: "選択肢6", required: true },
  { name: "選択肢7", required: true },
  { name: "選択肢8", required: true },
  { name: "選択肢9", required: true },
  { name: "選択肢10", required: true },
  { name: "選択肢11", required: true },
  { name: "選択肢12", required: true },
  { name: "選択肢13", required: true },
  { name: "選択肢14", required: true },
  { name: "選択肢15", required: true },
  { name: "選択肢16", required: true },
  { name: "選択肢17", required: true },
  { name: "選択肢18", required: true },
  { name: "選択肢19", required: true },
  { name: "選択肢20", required: true },
];

const postCSVColumnOutsideEntryFormOptionResult = [
  "サイトパス",
  "エントリーパートナー",
  "グループの指定",
  "質問名",
  "外部ETフォームでの表示",
  "チャットアプリ連携",
  "必須フラグ",
  "質問区分",
  "デフォルト値",
  "入力値の編集",
  "説明",
  "フラグ設定",
];

function OutsideEntryForm() {
  const setIsLoading = useSetAtom(AppAtoms.isLoading);
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  const loginUser = useAtomValue(AppAtoms.loginUser);

  // 各権限毎のヘッダーメニューの編集
  const addDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "外部ETフォーム登録",
    },
  ];
  const addCSVDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "質問登録CSV取込",
    },
  ];
  const getXLSXDataTypes: { auth: string[]; name: string }[] = [];
  const editDatasTypes: { auth: string[]; name: string }[] = [
    {
      name: "質問追加・削除",
      auth: ["マスターアカウント", "スタッフアカウント"],
    },
  ];

  const [addDataNames, setAddDataNames] = useState<string[]>([]);
  const [addDataName, setAddDataName] = useState<string>("");
  const [addCSVDataNames, setAddCSVDataNames] = useState<string[]>([]);
  const [addCSVDataName, setAddCSVDataName] = useState<string>("");
  const [getXLSXDataNames, setGetXLSXDataNames] = useState<string[]>([]);
  const [getXLSXDataName, setGetXLSXDataName] = useState<string>("");
  const [editDatasNames, setEditDatasNames] = useState<string[]>([]);
  const [editDatasName, setEditDatasName] = useState<string>("");

  useEffect(() => {
    let addDataNames: string[] = [];
    let addCSVDataNames: string[] = [];
    let getXLSXDataNames: string[] = [];
    let editDatasNames: string[] = [];
    addDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        addDataNames.push(dataType.name);
      }
    });
    setAddDataNames(addDataNames);
    addCSVDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        addCSVDataNames.push(dataType.name);
      }
    });
    setAddCSVDataNames(addCSVDataNames);
    getXLSXDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        getXLSXDataNames.push(dataType.name);
      }
    });
    setGetXLSXDataNames(getXLSXDataNames);
    editDatasTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        editDatasNames.push(dataType.name);
      }
    });
    setEditDatasNames(editDatasNames);
  }, [loginUser]);

  useEffect(() => {
    if (addDataName === "外部ETフォーム登録") {
      setOutsideEntryFormAddModal(true);
    }
  }, [addDataName]);

  useEffect(() => {
    if (addCSVDataName === "質問登録CSV取込") {
      setPostOutsideEntryFormOptionCSVStatus({
        status: "open",
        message: "",
        result: [],
        header_location: "None",
      });
    }
  }, [addCSVDataName]);

  useEffect(() => {
    if (editDatasName === "質問追加・削除") {
      setEditFormsStatus({
        ...editFormsStatus,
        status: "open",
      });
    }
  }, [editDatasName]);

  // サブテーブルデータの一覧取得
  const [getSubTableName, setGetSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  useEffect(() => {
    if (getSubTableName.name === "質問一覧") {
      getSubtableDataOption();
    }
    if (getSubTableName.name === "グループ一覧") {
      getSubtableDataEntryGroup();
    }
    if (getSubTableName.name === "SMS一覧") {
      getSubtableDataSMS();
    }
    if (getSubTableName.name === "外部用サービス一覧") {
      getSubtableDataService();
    }
    if (getSubTableName.name === "チャットアプリ連携一覧") {
      getSubtableDataChatApp();
    }
    if (getSubTableName.name === "解約SMS一覧") {
      getSubtableDataCancellSMS();
    }
  }, [getSubTableName.name, getSubTableName.key]);

  // サブテーブルデータの詳細取得
  const [getSubTableDetail, setGetSubTableDetail] = useState<{
    name: string;
    key: { [key: string]: string };
    dataDetail: {
      [key: string]:
        | number
        | string
        | { [key: string]: string | number }[]
        | { [key: string]: string | string[] };
    } | null;
  }>({
    name: "",
    key: {},
    dataDetail: null,
  });
  useEffect(() => {
    if (getSubTableDetail.name === "SMS詳細") {
      getSubtableDataDetailSMS();
    }
    if (getSubTableDetail.name === "外部用サービス詳細") {
      getSubtableDataDetailService();
    }
    if (getSubTableDetail.name === "チャットアプリ連携詳細") {
      getDataDetailOutsideEntryFormChatApp();
    }
    if (getSubTableDetail.name === "解約SMS詳細") {
      getSubtableDataDetailCancellSMS();
    }
  }, [getSubTableDetail.name, getSubTableDetail.key]);

  // サブテーブルデータの登録
  const [getSubTableAdd, setGetSubTableAdd] = useState<{
    name: string;
    row: dataDifine | null;
  }>({
    name: "",
    row: null,
  });
  useEffect(() => {
    if (getSubTableAdd.name === "グループ追加") {
      openModalSubtableDataAddEntryGroup();
    }
    if (getSubTableAdd.name === "SMS追加") {
      openModalSubtableDataAddSMS();
    }
    if (getSubTableAdd.name === "外部用サービス追加") {
      openModalSubtableDataAddService();
    }
    if (getSubTableAdd.name === "解約SMS追加") {
      openModalSubtableDataAddCancellSMS();
    }
    if (getSubTableAdd.name === "チャットアプリ連携追加") {
      setChatAppAddModal(true);
      setAddChatApp({
        ...addChatAppColumns,
        outside_entry_form_id: getSubTableAdd.row?.id?.toString() || "",
      });
    }
    if (getSubTableAdd.name === "質問一覧編集・追加" && getSubTableAdd.row) {
      openQuestionEditDirect({
        status: "before",
        editType: "text",
        tableId: "",
        id: Number(getSubTableAdd.row.id),
        key: "id",
        name: "質問一覧",
        value: "",
        editValue: "",
        editPhoneNumber: "",
        editName: "",
        editCustomerName: "",
        tel_flg: 0,
        name_flg: 0,
        company_name_flg: 0,
        half_width_number_flg: 0,
        customerList: [],
        payment_method_id: "",
        service_id: "",
        customer_picture: null,
      });
    }
  }, [getSubTableAdd.name, getSubTableAdd.row]);

  // サブサブテーブルデータの一覧取得
  const [getSubSubTableName, setGetSubSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  const [getSubSubTableDetail, setGetSubSubTableDetail] = useState<{
    name: string;
    key: { [key: string]: string };
    dataDetail: {
      [key: string]:
        | number
        | string
        | { [key: string]: string | number }[]
        | { [key: string]: string | string[] };
    } | null;
  }>({ name: "", key: {}, dataDetail: null });
  useEffect(() => {
    if (getSubSubTableName.name === "内部サービス紐づけ一覧") {
      getSubSubtableDataInsideService();
    }
    if (getSubSubTableName.name === "選択肢一覧") {
      getSubSubtableDataSelect();
    }
    if (getSubSubTableName.name === "依存外部サービス一覧") {
      getSubSubtableDataDependService();
    }
    if (getSubSubTableName.name === "依存質問-選択肢一覧") {
      getSubSubtableDataDependSelect();
    }
    if (getSubSubTableName.name === "チャット連携-依存質問-選択肢一覧") {
      getSubSubtableDataOutsideEntryFormChatAppDependSelect();
    }
  }, [getSubSubTableName.name, getSubSubTableName.key]);

  // サブテーブルデータの登録
  const [getSubSubTableAdd, setGetSubSubTableAdd] = useState<{
    name: string;
    row: dataDifine | null;
  }>({
    name: "",
    row: null,
  });
  const [onChatAppDependSelectAddModal, setOnChatAppDependSelectAddModal] =
    useState(false);
  const [
    onChatAppDependSelectAddModalResult,
    setOnChatAppDependSelectAddModalResult,
  ] = useState("");
  const [addChatAppDependSelect, setAddChatAppDependSelect] = useState<{
    outside_entry_form_chat_app_id: string;
    option_id: string;
    outside_option_select_id: string;
  }>({
    outside_entry_form_chat_app_id: "",
    option_id: "",
    outside_option_select_id: "",
  });
  const [
    outsideEntryFormOptionsForChatAppDependFull,
    setOutsideEntryFormOptionsForChatAppDependFull,
  ] = useState<
    {
      option_id: number;
      option_name: string;
      option_selects: { id: number; option_select: string }[];
    }[]
  >([]);
  const chatAppDependSelectAddSubDataColumn = [
    {
      key: "option_id",
      name: "質問",
      table: false,
      tableValue: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "id",
      add: true,
      addType: "list" as const,
      addMessage: "",
    },
    {
      key: "outside_option_select_id",
      name: "選択肢",
      table: false,
      tableValue: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "id",
      add: true,
      addType: "list" as const,
      addMessage: "",
    },
  ];
  useEffect(() => {
    if (getSubSubTableAdd.name === "内部サービス紐づけ追加") {
      openModalSubSubtableDataAddInsideService();
    }
    if (
      getSubSubTableAdd.name === "依存質問-選択肢追加" &&
      getSubTableName.name === "チャットアプリ連携一覧"
    ) {
      const chatAppId =
        getSubSubTableAdd.row?.id != null
          ? String(getSubSubTableAdd.row.id)
          : getSubSubTableName.key?.id;
      if (chatAppId) {
        setAddChatAppDependSelect({
          outside_entry_form_chat_app_id: chatAppId,
          option_id: "",
          outside_option_select_id: "",
        });
        const outsideEntryFormId = getSubTableName.key.id;
        setIsLoading(true);
        if (outsideEntryFormId) {
          getOutsideEntryFormOptionsForChatAppDepend(outsideEntryFormId).then(
            (
              list: {
                option_id: number;
                option_name: string;
                option_selects: { id: number; option_select: string }[];
              }[],
            ) => {
              setOutsideEntryFormOptionsForChatAppDependFull(list);
              setOnChatAppDependSelectAddModal(true);
              setIsLoading(false);
            },
          );
        } else {
          setOutsideEntryFormOptionsForChatAppDependFull([]);
          setOnChatAppDependSelectAddModal(true);
          setIsLoading(false);
        }
      }
    }
  }, [
    getSubSubTableAdd.name,
    getSubSubTableAdd.row,
    getSubSubTableName.name,
    getSubSubTableName.key.id,
    getSubTableName.name,
    getSubTableName.key.id,
  ]);
  // テーブル関数
  const [tableOriginalFunc, setTableOriginalFunc] = useState<{
    name: string;
    key: { [key: string]: string };
    subTableColumnName?: string;
  }>({
    name: "",
    key: {},
  });
  useEffect(() => {
    if (
      tableOriginalFunc.name === "削除" &&
      tableOriginalFunc.subTableColumnName ===
        "チャット連携-依存質問-選択肢一覧"
    ) {
      setDeleteChatAppDependSelectInf({
        status: "open",
        key: tableOriginalFunc.key,
        message: "",
      });
    } else if (
      tableOriginalFunc.name === "削除" &&
      tableOriginalFunc.subTableColumnName === "チャットアプリ連携一覧"
    ) {
      setDeleteChatAppInf({
        status: "open",
        key: tableOriginalFunc.key,
        message: "",
      });
    } else if (
      tableOriginalFunc.name === "削除" &&
      tableOriginalFunc.subTableColumnName === "SMS一覧"
    ) {
      setDeleteSMSInf({
        status: "open",
        name: "SMS設定の削除",
        key: tableOriginalFunc.key,
        message: "",
      });
    } else if (
      tableOriginalFunc.name === "削除" &&
      tableOriginalFunc.subTableColumnName === "外部用サービス一覧"
    ) {
      setDeleteServiceInf({
        status: "open",
        name: "外部用サービスの削除",
        key: tableOriginalFunc.key,
        message: "",
      });
    } else if (
      tableOriginalFunc.name === "削除" &&
      tableOriginalFunc.subTableColumnName === "解約SMS一覧"
    ) {
      setDeleteCancellSMSInf({
        status: "open",
        name: "解約SMSの削除",
        key: tableOriginalFunc.key,
        message: "",
      });
    } else if (tableOriginalFunc.name === "削除") {
      setDeleteDataInf({
        status: "open",
        key: tableOriginalFunc.key,
        message: "",
      });
    }
  }, [
    tableOriginalFunc.name,
    tableOriginalFunc.key,
    tableOriginalFunc.subTableColumnName,
  ]);

  const [serchOpen, setSerchOpen] = useState(false);
  const aiChatOpen = useAtomValue(AppAtoms.aiChatOpen);
  const setAiChatOpenAtom = useSetAtom(AppAtoms.aiChatOpen);
  // cmd-po_1168 SP排他: AI open時に検索を close
  useEffect(() => {
    if (aiChatOpen && isSmartPhone) setSerchOpen(false);
  }, [aiChatOpen, isSmartPhone]);
  const handleSetSerchOpen = (open: boolean) => {
    setSerchOpen(open);
    if (open && isSmartPhone) setAiChatOpenAtom(false);
  };

  const firstYear = getFirstYear();
  const { thisYear, thisMonth, lastYear, lastMonth } = getOneYear();

  // 表示数・ページ
  const [displayNumber, setDisplayNumber] = useState(50);
  const displayNumbers = [25, 50, 100, 250, 500];
  const [pageNumber, setPageNumber] = useState(1);
  const [maxPageNumber, setMaxPageNumber] = useState(1);

  // 検索項目
  const serchColumn = outsideEntryFormTableColumn.dataColumn.reduce(
    (column, difine) => {
      if (difine.serch === true) {
        if (difine.serchType === "date") {
          return {
            ...column,
            [difine.key + "_start"]: "",
            [difine.key + "_end"]: "",
          };
        } else if (difine.serchType === "payment_year_month") {
          return {
            ...column,
            payment_year: thisYear.toString(),
            payment_month: thisMonth.toString(),
          };
        } else {
          return {
            ...column,
            [difine.key]: "",
          };
        }
      } else {
        return {
          ...column,
        };
      }
    },
    {},
  );
  const [serchString, setSerchString] = useState(serchColumn);
  const [serchStringView, setSerchStringView] = useState(serchColumn);

  // テーブルデータ
  const [fetchData, setFetchData] = useState<dataDifine[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  async function getTableData(edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const fetchData = await getOutsideEntryForms({
      ...serchString,
      displayNumber,
      pageNumber,
    });
    if (fetchData === null) {
      setFetchData([]);
      setTotalCount(0);
      setMaxPageNumber(1);
      setPageNumber(1);
    } else if (fetchData) {
      setFetchData(fetchData.outsideEntryForms);
      const countOutsideEntryForms = Number(fetchData.countOutsideEntryForms);
      setTotalCount(countOutsideEntryForms);
      setMaxPageNumber(Math.ceil(countOutsideEntryForms / displayNumber));
    }
    if (!edit) {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    getTableData(false);
  }, [serchString, displayNumber, pageNumber]);

  // 詳細取得
  const [dataDetail, setDataDetail] = useState<{
    [key: string]: number | string | { [key: string]: string | number }[];
  } | null>(null);

  async function getDataDetail(key: { [key: string]: string }, edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const id = key.id;
    const dataDetail = await getOutsideEntryForm(id);
    setDataDetail(dataDetail);
    if (!edit) {
      setDetailView(true);
      setDetailBreadcrumb({
        crumb: "マスタ設定 / フォーム管理 / ",
        title: outsideEntryFormTableColumn.detailTitle,
      });
      setIsLoading(false);
    }
  }

  const [detailView, setDetailView] = useState<boolean>(false);
  const setDetailBreadcrumb = useSetAtom(AppAtoms.detailBreadcrumb);
  function closeDetailView() {
    setDetailView(false);
    setDataDetail(null);
    setDetailBreadcrumb(null);
  }

  // 編集
  const [editData, setEditData] = useState<EditDataDifine | null>(null);

  // optimistic overlay helper: getTableData 解決の【後】に呼ぶこと
  // (getTableData は setFetchData を丸ごと置換するため、前に呼ぶと stale 応答が overlay を上書きし race が復活する)
  function applyEditOptimistic(ed: EditDataDifine) {
    let displayValue: string;
    if (ed.editType === "list") {
      const found = LIST_POST[ed.key]?.find(
        (o) => String(o.id) === String(ed.editValue)
      );
      displayValue = found ? found.value : String(ed.editValue);
    } else {
      displayValue = String(ed.editValue);
    }
    setFetchData((prev) =>
      prev.map((row) =>
        String(row.id) === String(ed.tableId)
          ? { ...row, [ed.key]: displayValue }
          : row
      )
    );
  }

  async function putEditData() {
    if (editData !== null) {
      setIsLoading(true);
      const id = editData.tableId as string;
      setEditData({
        ...editData,
        status: "editing",
      });
      const putResponce = await putOutsideEntryForm(editData);
      await getDataDetail({ id }, true);
      await getTableData(true);
      applyEditOptimistic(editData); // ★ getTableData 後に overlay（順序厳守）
      setEditData({
        ...editData,
        status: putResponce,
      });
      setIsLoading(false);
    }
  }

  // 外部ETフォーム新規作成
  const addOutsideEntryFormColumns =
    outsideEntryFormTableColumn.dataColumn.reduce((column, difine) => {
      if (difine.add) {
        return {
          ...column,
          [difine.key]: "",
        };
      } else {
        return {
          ...column,
        };
      }
    }, {});
  const [onDataAddModalResult, setOnDataAddModalResult] = useState("");
  const [addOutsideEntryForm, setAddOutsideEntryForm] = useState<{
    [key: string]: string | boolean | any[];
  }>(addOutsideEntryFormColumns);
  const [onOutsideEntryFormAddModal, setOutsideEntryFormAddModal] =
    useState(false);
  async function postAddOutsideEntryForm() {
    setIsLoading(true);
    setOutsideEntryFormAddModal(false);
    const postResponce = await postOutsideEntryForm(addOutsideEntryForm);
    if (postResponce === "success") {
      await getTableData(false);
      setAddOutsideEntryForm(addOutsideEntryFormColumns);
      setOnDataAddModalResult("success");
    } else {
      setOutsideEntryFormAddModal(true);
      setOnDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // 質問一覧編集
  const [editOutsideEntryFormOption, setEditOutsideEntryFormOption] = useState<{
    [key: string]: any;
  } | null>(null);
  const [editOutsideServices, setEditOutsideServices] = useState<
    {
      outside_entry_form_service_id: number;
      outside_entry_form_service_name: string;
    }[]
  >([]);
  async function putEditOutsideEntryFormOption() {
    if (editOutsideEntryFormOption !== null) {
      const id = editOutsideEntryFormOption.tableId as string;
      setIsLoading(true);
      setEditOutsideEntryFormOption({
        ...editOutsideEntryFormOption,
        status: "editing",
      });
      const putResult = await putOutsideEntryFormOptions(
        editOutsideEntryFormOption,
      );
      if (putResult?.edit == "success") {
        if (getSubTableName.key.id && getSubTableName.name === "質問一覧") {
          await getSubtableDataOption();
        }
        if (
          getSubTableName.key.id &&
          getSubTableName.name === "チャットアプリ連携一覧"
        ) {
          await getSubtableDataChatApp();
        }
        if (
          getSubSubTableName.key.id &&
          getSubSubTableName.name === "チャット連携-依存質問-選択肢一覧"
        ) {
          await getSubSubtableDataOutsideEntryFormChatAppDependSelect();
        }
        setIsLoading(true);
        await getTableData(true);
      }
      setEditOutsideEntryFormOption({
        ...editOutsideEntryFormOption,
        status: putResult?.warning || putResult?.edit || "failed",
      });
      setIsLoading(false);
    }
  }

  async function openQuestionEditDirect(editData: EditDataDifine | null) {
    if (editData === null || editData.name !== "質問一覧") {
      return;
    }
    setIsLoading(true);
    setEditOutsideEntryFormOption({
      status: "editing",
    });
    const { detail_data, option_data } = await getOutsideEntryFormOption(
      String(editData.id),
    );
    if (!detail_data) {
      setEditOutsideEntryFormOption(null);
      setIsLoading(false);
      setGetSubTableAdd({ name: "", row: null });
      return;
    }
    let product_key = "1";
    const { outside_service_data, fetch_product_key } =
      await getOutsideEntryFormOptionsDependServices(
        detail_data.outside_entry_form_id as string,
      );
    setEditOutsideServices(outside_service_data);
    product_key = fetch_product_key;
    const optionIndex = option_data.findIndex(
      (option) => String(option.option_id) === String(editData.tableId),
    );
    setEditOutsideEntryFormOption({
      status: "before",
      select_option_index: optionIndex >= 0 ? optionIndex : null,
      select_option: optionIndex >= 0 ? option_data[optionIndex] : null,
      add_select_option_flg: false,
      tableId: detail_data.id as number,
      product_option: option_data.length == 0 ? [] : option_data,
      delete_option: [],
      product_key: product_key,
      product_contract_number: "0",
      product_name: detail_data.product_name,
      entry_form_id: detail_data.entry_form_id,
      entry_sale_company_name: detail_data.entry_sale_company_name,
      category_name: detail_data.category_name,
      toss_up_form_id: detail_data.toss_up_form_id,
      toss_up_company_name: detail_data.toss_up_company_name,
      outside_entry_form_id: detail_data.outside_entry_form_id,
    });
    setIsLoading(false);
  }

  // 外部ETフォーム一括編集
  const [editFormsStatus, setEditFormsStatus] = useState<{
    status:
      | "none"
      | "open"
      | "add"
      | "delete"
      | "success"
      | "loading"
      | "add_error"
      | "delete_error";
    message: string;
    editIDs: number[];
    action: null | 0 | 1;
    delete_option_names: string[];
    select_option: {
      option_name: string;
      outside_form_display: 0 | 1;
      sns_send: 0 | 1;
      required_optional: 0 | 1;
      option_type: 0 | 1 | 2 | 3 | 4;
      option_default_value: string;
      change_value_conf: 0 | 1;
      option_comment: string;
      tel_flg: 0 | 1;
      name_flg: 0 | 1;
      company_name_flg: 0 | 1;
      zip_code_flg: 0 | 1;
      address_flg: 0 | 1;
      space_flg: 0 | 1;
      mail_address_flg: 0 | 1;
      form_tel_flg: 0 | 1;
      multi_text_flg: 0 | 1;
      contract_number_flg: 0 | 1;
      half_width_number_flg: 0 | 1;
      option_select: string[];
    };
  }>({
    status: "none",
    message: "",
    editIDs: [],
    action: null,
    delete_option_names: [],
    select_option: {
      option_name: "",
      outside_form_display: 0,
      sns_send: 1,
      required_optional: 0,
      option_type: 0,
      option_default_value: "",
      change_value_conf: 0,
      option_comment: "",
      tel_flg: 0,
      name_flg: 0,
      company_name_flg: 0,
      zip_code_flg: 0,
      address_flg: 0,
      space_flg: 0,
      mail_address_flg: 0,
      form_tel_flg: 0,
      multi_text_flg: 0,
      contract_number_flg: 0,
      half_width_number_flg: 0,
      option_select: [""],
    },
  });
  useEffect(() => {
    if (editFormsStatus.status === "loading") {
      setIsLoading(true);
    } else if (editFormsStatus.status !== "none") {
      setIsLoading(false);
    }
  }, [editFormsStatus]);
  const [editFormOptionNames, setEditFormOptionNames] = useState<string[]>([]);
  async function getEditFormDeleteOptionNames() {
    setEditFormsStatus({
      ...editFormsStatus,
      status: "loading",
    });
    const optionName = await getOutsideEntryFormDeleteOptionNames(
      editFormsStatus.editIDs,
    );
    if (optionName.length > 0) {
      setEditFormsStatus({
        ...editFormsStatus,
        status: "delete",
      });
      let editFormOptionNames: string[] = [];
      optionName.map((option) => {
        editFormOptionNames.push(option.option_name);
      });
      setEditFormOptionNames(editFormOptionNames);
    } else {
      setEditFormsStatus({
        ...editFormsStatus,
        status: "delete_error",
        message: "選択したフォームに共通の質問が存在しません。",
      });
    }
  }

  async function postEditFormOption() {
    setEditFormsStatus({
      ...editFormsStatus,
      status: "loading",
    });
    const responce = await postOutsideEntryFormOptions(
      editFormsStatus.editIDs,
      editFormsStatus.select_option,
    );
    if (responce == "success") {
      if (getSubTableName.name === "質問一覧") {
        await getSubtableDataOption();
      }
      setEditFormsStatus({
        ...editFormsStatus,
        status: "success",
      });
    } else {
      setEditFormsStatus({
        ...editFormsStatus,
        status: "add_error",
        message: responce,
      });
    }
  }

  async function deleteEditFormOption() {
    setEditFormsStatus({
      ...editFormsStatus,
      status: "loading",
    });
    const responce = await deleteOutsideEntryFormOptions(
      editFormsStatus.editIDs,
      editFormsStatus.delete_option_names,
    );
    if (responce == "success") {
      if (getSubTableName.name === "質問一覧") {
        await getSubtableDataOption();
      }
      setEditFormsStatus({
        ...editFormsStatus,
        status: "success",
      });
    } else {
      setEditFormsStatus({
        ...editFormsStatus,
        status: "delete_error",
        message: responce,
      });
    }
  }
  // 質問登録CSV取込
  const [
    postOutsideEntryFormOptionCSVStatus,
    setPostOutsideEntryFormOptionCSVStatus,
  ] = useState<{
    status: "none" | "open" | "posting" | "result" | "loading" | "error";
    message: string;
    result: { [key: string]: any }[];
    header_location: string;
  }>({
    status: "none",
    message: "",
    result: [],
    header_location: "None",
  });
  async function postProductsCSV(postDatas: File) {
    setPostOutsideEntryFormOptionCSVStatus({
      status: "loading",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });
    // 著名付きURL(post用)を作成
    const fileName = postDatas.name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const { presigned_object, destination_key } = await getPresignedPostCSV(
      nowTimeName,
      fileName,
    );
    // POSTする form に持たせるデータを生成する
    const formData = new FormData();
    for (const key in presigned_object.fields) {
      formData.append(key, presigned_object.fields[key]);
    }
    formData.append("file", postDatas);
    // ファイルをS3にアップロード
    const r = await postPresignedPost(presigned_object.url, formData);
    if (r !== "seccess") {
      setPostOutsideEntryFormOptionCSVStatus({ status: "error", message: "CSVファイルのアップロードに失敗しました。もう一度お試しください。", result: [], header_location: "None" });
      return;
    }

    setPostOutsideEntryFormOptionCSVStatus({
      status: "posting",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });

    const path = "outsideEntryFormOption";
    const idToken = loginUser?.idToken;
    const bodys = {
      type: "post_csv",
      path: path,
      destination_key: destination_key,
      idToken,
    };

    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url = CONST.inputCSVWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        setPostOutsideEntryFormOptionCSVStatus({
          status: "loading",
          message: "CSV取込完了",
          result: postOutsideEntryFormOptionCSVStatus.result,
          header_location: decodedData.header_location,
        });
        // await getProductList();
        if (getSubTableName.key.id) {
          await getSubtableDataOption();
        }
        await getTableData(true);
        setPostOutsideEntryFormOptionCSVStatus({
          status: "result",
          message: "CSV取込完了",
          result: postOutsideEntryFormOptionCSVStatus.result,
          header_location: decodedData.header_location,
        });
        websocket.close();
      } else if (decodedData.message === "header_error") {
        setPostOutsideEntryFormOptionCSVStatus({
          status: "error",
          message:
            "「" + decodedData.header + "」がCSV項目に含まれていません。",
          result: [],
          header_location: "None",
        });
        websocket.close();
      } else if (decodedData.message === "encoding_error") {
        setPostOutsideEntryFormOptionCSVStatus({
          status: "error",
          message:
            "CSVファイルを読み取れませんでした。\nExcelでファイルを開き、「名前を付けて保存」→ ファイルの種類で 「CSV UTF-8（コンマ区切り）(*.csv)」 を選んで保存し直し、もう一度アップロードしてください。",
          result: [],
          header_location: "None",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        let _result = postOutsideEntryFormOptionCSVStatus.result;
        if (decodedData.res_results) {
          _result.push(decodedData.res_results);
        }
        setPostOutsideEntryFormOptionCSVStatus({
          status: "posting",
          message: decodedData.message,
          result: _result,
          header_location: "None",
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }

  // サブテーブルデータの登録結果（共通）
  const [onSubtableDataAddModalResult, setOnSubtableDataAddModalResult] =
    useState("");

  // 質問一覧取得
  async function getSubtableDataOption() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getOutsideEntryFormOptions(
        getSubTableName.key.id,
      );
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // チャットアプリ連携一覧取得
  async function getSubtableDataChatApp() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getOutsideEntryFormChatApps(
        getSubTableName.key.id,
      );
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // チャットアプリ連携詳細取得
  const [dataDetailChatApp, setDataDetailChatApp] = useState<{
    [key: string]:
      | number
      | string
      | { [key: string]: string | number }[]
      | { [key: string]: string | string[] };
  } | null>(null);
  async function getDataDetailOutsideEntryFormChatApp() {
    setIsLoading(true);
    const id = getSubTableDetail.key.id;
    const dataDetail = await getOutsideEntryFormChatApp(id);
    setGetSubTableDetail({
      ...getSubTableDetail,
      dataDetail: dataDetail,
    });
    setDataDetailChatApp(dataDetail);
    setIsLoading(false);
  }

  // チャットアプリ連携編集
  const [editChatAppData, setEditChatAppData] = useState<EditDataDifine | null>(
    null,
  );
  async function putEditChatAppData() {
    if (editChatAppData !== null) {
      setIsLoading(true);
      const id = editChatAppData.tableId as string;
      setEditChatAppData({
        ...editChatAppData,
        status: "editing",
      });
      const putResponce = await putOutsideEntryFormChatApp(editChatAppData);
      await getDataDetailOutsideEntryFormChatApp();
      await getSubtableDataChatApp();
      await getTableData(true);
      setEditChatAppData({
        ...editChatAppData,
        status: putResponce,
      });
      setIsLoading(false);
    }
  }

  // チャットアプリ連携新規作成
  const addChatAppColumns =
    outsideEntryFormTableColumn.subTable[1].subDataColumn.reduce(
      (column, difine) => {
        if (difine.add) {
          return {
            ...column,
            [difine.key]: "",
          };
        } else {
          return {
            ...column,
          };
        }
      },
      {},
    );
  const [onChatAppAddModalResult, setOnChatAppAddModalResult] = useState("");
  const [addChatApp, setAddChatApp] = useState<{
    [key: string]: string | boolean | any[];
  }>(addChatAppColumns);
  const [onChatAppAddModal, setChatAppAddModal] = useState(false);
  async function postAddChatApp() {
    setIsLoading(true);
    setChatAppAddModal(false);
    const postResponce = await postOutsideEntryFormChatApp(addChatApp);
    if (postResponce === "success") {
      await getSubtableDataChatApp();
      await getTableData(true);
      setAddChatApp(addChatAppColumns);
      setOnChatAppAddModalResult("success");
    } else {
      setChatAppAddModal(true);
      setOnChatAppAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // チャットアプリ連携削除
  const [deleteChatAppInf, setDeleteChatAppInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }>({
    status: null,
    key: {},
    message: "",
  });
  async function deleteChatAppData() {
    setDeleteChatAppInf({
      ...deleteChatAppInf,
      status: "loading",
    });
    const id = deleteChatAppInf.key.id;
    const responce = await deleteOutsideEntryFormChatApp(id);
    if (responce == "success") {
      await getSubtableDataChatApp();
      await getTableData(true);
      setDeleteChatAppInf({
        ...deleteChatAppInf,
        status: "success",
      });
    } else {
      setDeleteChatAppInf({
        ...deleteChatAppInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (deleteChatAppInf.status === "loading") {
      setIsLoading(true);
    } else if (deleteChatAppInf.status !== null) {
      setIsLoading(false);
    }
  }, [deleteChatAppInf]);

  // 外部ETフォーム - 質問一覧取得
  async function getSubSubtableDataSelect() {
    if (getSubSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getOutsideEntryFormOptionSelects(
        getSubSubTableName.key.id,
      );
      setGetSubSubTableName({
        ...getSubSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // 外部ETフォーム - 依存商材一覧取得
  async function getSubSubtableDataDependService() {
    if (getSubSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getOutsideEntryFormOptionDependServices(
        getSubSubTableName.key.id,
      );
      setGetSubSubTableName({
        ...getSubSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // 外部ETフォーム - 依存質問-選択肢一覧取得
  async function getSubSubtableDataDependSelect() {
    if (getSubSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getOutsideEntryFormOptionDependSelects(
        getSubSubTableName.key.id,
      );
      setGetSubSubTableName({
        ...getSubSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // 外部ET - チャット連携-依存質問-選択肢一覧取得
  async function getSubSubtableDataOutsideEntryFormChatAppDependSelect() {
    if (getSubSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getOutsideEntryFormChatAppDependSelects(
        getSubSubTableName.key.id,
      );
      setGetSubSubTableName({
        ...getSubSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  async function postAddChatAppDependSelect() {
    if (
      !addChatAppDependSelect.outside_entry_form_chat_app_id ||
      !addChatAppDependSelect.outside_option_select_id
    )
      return;
    setOnChatAppDependSelectAddModal(false);
    setIsLoading(true);
    try {
      const res = await postOutsideEntryFormChatAppDependSelect({
        ...addChatAppDependSelect,
        outside_option_select_id: Number(
          addChatAppDependSelect.outside_option_select_id,
        ),
      });
      if (res === "success") {
        getSubSubtableDataOutsideEntryFormChatAppDependSelect();
        getSubtableDataChatApp();
        setAddChatAppDependSelect({
          outside_entry_form_chat_app_id: "",
          option_id: "",
          outside_option_select_id: "",
        });
        setOnChatAppDependSelectAddModalResult("success");
      } else {
        setOnChatAppDependSelectAddModal(true);
        setOnChatAppDependSelectAddModalResult(
          res || "データの登録に失敗しました。",
        );
      }
    } finally {
      setIsLoading(false);
    }
  }

  const [deleteChatAppDependSelectInf, setDeleteChatAppDependSelectInf] =
    useState<{
      status: null | "loading" | "open" | "success" | "failed";
      key: { [key: string]: string };
      message: string;
    }>({ status: null, key: {}, message: "" });

  // エントリーグループ一覧取得
  async function getSubtableDataEntryGroup() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getOutsideEntryFormGroups(getSubTableName.key.id);
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // エントリー閲覧可能グループ登録
  const [addDataEntryGroup, setAddDataEntryGroup] = useState<{
    [key: string]: string | boolean | any[];
  }>({
    outside_entry_form_id: "",
    all_group: [],
    select_group: [],
  });
  const [onDataAddModalEntryGroup, setOnDataAddModalEntryGroup] =
    useState(false);
  async function openModalSubtableDataAddEntryGroup() {
    if (getSubTableAdd.row) {
      setIsLoading(true);
      const fetchData = await getOutsideEntryFormGroups(
        getSubTableAdd.row.id as string,
      );
      setAddDataEntryGroup({
        outside_entry_form_id: getSubTableAdd.row.id as string,
        all_group: fetchData.groupDatas,
        select_group: fetchData.sudDatas,
      });
      setOnDataAddModalEntryGroup(true);
      setIsLoading(false);
    }
  }
  async function postAddDataEntryGroup() {
    setIsLoading(true);
    setOnDataAddModalEntryGroup(false);
    const postResponce = await postOutsideEntryFormGroups(addDataEntryGroup);
    if (postResponce === "success") {
      if (getSubTableName.name == "グループ一覧") {
        await getSubtableDataEntryGroup();
      }
      setIsLoading(true);
      await getTableData(true);
      setAddDataEntryGroup({
        outside_entry_form_id: "",
        all_group: [],
        select_group: [],
      });
      setOnSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalEntryGroup(true);
      setOnSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // SMS一覧取得
  async function getSubtableDataSMS() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getOutsideEntryFormSMSs(getSubTableName.key.id);
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // SMS詳細取得
  async function getSubtableDataDetailSMS() {
    if (getSubTableDetail.key.id) {
      setIsLoading(true);
      const dataDetail = await getOutsideEntryFormSMS(getSubTableDetail.key.id);
      setGetSubTableDetail({
        ...getSubTableDetail,
        dataDetail,
      });
      setIsLoading(false);
    }
  }

  // SMS編集
  const [editDataDetailSMS, setEditDataDetailSMS] =
    useState<EditDataDifine | null>(null);
  async function putEditDataDetailSMS() {
    if (editDataDetailSMS !== null) {
      setIsLoading(true);
      setEditDataDetailSMS({
        ...editDataDetailSMS,
        status: "editing",
      });
      const putResponce = await putOutsideEntryFormSMS(editDataDetailSMS);
      if (putResponce == "success") {
        await getSubtableDataSMS();
        await getSubtableDataDetailSMS();
      }
      setEditDataDetailSMS({
        ...editDataDetailSMS,
        status: putResponce,
      });
      setIsLoading(false);
    }
  }

  // SMS新規登録
  const addDataColumnsSMS =
    outsideEntryFormTableColumn.subTable[3].subDataColumn.reduce(
      (column, difine) => {
        if (difine.add) {
          if (difine.addType === "date") {
            return {
              ...column,
              [difine.key + "_year"]: thisYear.toString(),
              [difine.key + "_month"]: thisMonth.toString(),
              [difine.key + "_date"]: "1",
            };
          } else {
            return {
              ...column,
              [difine.key]: "",
            };
          }
        } else {
          return {
            ...column,
          };
        }
      },
      {},
    );
  const [addDataSMS, setAddDataSMS] = useState<{
    [key: string]: string | boolean | any[];
  }>(addDataColumnsSMS);
  const [onDataAddModalSMS, setOnDataAddModalSMS] = useState(false);
  async function openModalSubtableDataAddSMS() {
    let _addDataSMS = addDataSMS;
    outsideEntryFormTableColumn.subTable[3].subDataColumn.map((difine) => {
      if (difine.add && getSubTableAdd.row) {
        if (difine.addType === "tableId") {
          _addDataSMS[difine.key] = getSubTableAdd.row.id.toString();
        } else if (difine.addType === "tableSubId") {
          _addDataSMS[difine.key] = getSubTableAdd.row[difine.key].toString();
        } else if (difine.addType === "tableData") {
          _addDataSMS[difine.key] = getSubTableAdd.row[difine.key] as string;
        }
      }
    });
    setAddDataSMS(_addDataSMS);
    if (getSubTableAdd.row) {
      setOnDataAddModalSMS(true);
    }
  }
  async function postAddDataSMS() {
    setIsLoading(true);
    setOnDataAddModalSMS(false);
    const postResponce = await postOutsideEntryFormSMS(addDataSMS);
    if (postResponce === "success") {
      await getTableData(true);
      if (getSubTableName.name == "SMS一覧") {
        await getSubtableDataSMS();
      }
      setAddDataSMS(addDataColumnsSMS);
      setOnSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalSMS(true);
      setOnSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // SMSの削除
  const [deleteSMSInf, setDeleteSMSInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    name: string;
    message: string;
  }>({
    status: null,
    name: "",
    key: {},
    message: "",
  });
  async function deleteSMSFunc() {
    setDeleteSMSInf({
      ...deleteSMSInf,
      status: "loading",
    });
    const id = deleteSMSInf.key.id;
    const responce = await deleteOutsideEntryFormSMS(id);
    if (responce == "success") {
      await getTableData(false);
      await getSubtableDataSMS();
      setDeleteSMSInf({
        ...deleteSMSInf,
        status: "success",
      });
    } else {
      setDeleteSMSInf({
        ...deleteSMSInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (deleteSMSInf.status === "loading") {
      setIsLoading(true);
    } else if (deleteSMSInf.status !== null) {
      setIsLoading(false);
    }
  }, [deleteSMSInf]);

  // 解約SMS一覧取得
  async function getSubtableDataCancellSMS() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getOutsideEntryFormCancellSMSs(
        getSubTableName.key.id,
      );
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // 解約SMS詳細取得
  async function getSubtableDataDetailCancellSMS() {
    if (getSubTableDetail.key.id) {
      setIsLoading(true);
      const dataDetail = await getOutsideEntryFormCancellSMS(
        getSubTableDetail.key.id,
      );
      setGetSubTableDetail({
        ...getSubTableDetail,
        dataDetail,
      });
      setIsLoading(false);
    }
  }

  // 解約SMS編集
  const [editDataDetailCancellSMS, setEditDataDetailCancellSMS] =
    useState<EditDataDifine | null>(null);
  async function putEditDataDetailCancellSMS() {
    if (editDataDetailCancellSMS !== null) {
      setIsLoading(true);
      setEditDataDetailCancellSMS({
        ...editDataDetailCancellSMS,
        status: "editing",
      });
      const putResponce = await putOutsideEntryFormCancellSMS(
        editDataDetailCancellSMS,
      );
      if (putResponce == "success") {
        await getSubtableDataCancellSMS();
        await getSubtableDataDetailCancellSMS();
      }
      setEditDataDetailCancellSMS({
        ...editDataDetailCancellSMS,
        status: putResponce,
      });
      setIsLoading(false);
    }
  }

  // 解約SMS新規登録
  const addDataColumnsCancellSMS =
    outsideEntryFormTableColumn.subTable[4].subDataColumn.reduce(
      (column, difine) => {
        if (difine.add) {
          return { ...column, [difine.key]: "" };
        }
        return { ...column };
      },
      {},
    );
  const [addDataCancellSMS, setAddDataCancellSMS] = useState<{
    [key: string]: string | boolean | any[];
  }>(addDataColumnsCancellSMS);
  const [onDataAddModalCancellSMS, setOnDataAddModalCancellSMS] =
    useState(false);
  async function openModalSubtableDataAddCancellSMS() {
    let _addDataCancellSMS = addDataCancellSMS;
    outsideEntryFormTableColumn.subTable[4].subDataColumn.forEach((difine) => {
      if (difine.add && getSubTableAdd.row) {
        if (difine.addType === "tableId") {
          _addDataCancellSMS[difine.key] = getSubTableAdd.row.id.toString();
        } else if (difine.addType === "tableData") {
          _addDataCancellSMS[difine.key] = getSubTableAdd.row[
            difine.key
          ] as string;
        }
      }
    });
    setAddDataCancellSMS(_addDataCancellSMS);
    if (getSubTableAdd.row) {
      setOnDataAddModalCancellSMS(true);
    }
  }
  async function postAddDataCancellSMS() {
    setIsLoading(true);
    setOnDataAddModalCancellSMS(false);
    const postResponce =
      await postOutsideEntryFormCancellSMS(addDataCancellSMS);
    if (postResponce === "success") {
      await getTableData(true);
      if (getSubTableName.name === "解約SMS一覧") {
        await getSubtableDataCancellSMS();
      }
      setAddDataCancellSMS(addDataColumnsCancellSMS);
      setOnSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalCancellSMS(true);
      setOnSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // 解約SMS削除
  const [deleteCancellSMSInf, setDeleteCancellSMSInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    name: string;
    message: string;
  }>({
    status: null,
    name: "",
    key: {},
    message: "",
  });
  async function deleteCancellSMSFunc() {
    setDeleteCancellSMSInf({
      ...deleteCancellSMSInf,
      status: "loading",
    });
    const id = deleteCancellSMSInf.key.id;
    const responce = await deleteOutsideEntryFormCancellSMS(id);
    if (responce === "success") {
      await getTableData(false);
      await getSubtableDataCancellSMS();
      setDeleteCancellSMSInf({
        ...deleteCancellSMSInf,
        status: "success",
      });
    } else {
      setDeleteCancellSMSInf({
        ...deleteCancellSMSInf,
        status: "failed",
        message: responce ?? "",
      });
    }
  }
  useEffect(() => {
    if (deleteCancellSMSInf.status === "loading") {
      setIsLoading(true);
    } else if (deleteCancellSMSInf.status !== null) {
      setIsLoading(false);
    }
  }, [deleteCancellSMSInf]);

  // 外部用サービス一覧取得
  async function getSubtableDataService() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getOutsideEntryFormServices(
        getSubTableName.key.id,
      );
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // 外部用サービス詳細取得
  async function getSubtableDataDetailService() {
    if (getSubTableDetail.key.id) {
      setIsLoading(true);
      const dataDetail = await getOutsideEntryFormService(
        getSubTableDetail.key.id,
      );
      setGetSubTableDetail({
        ...getSubTableDetail,
        dataDetail,
      });
      setIsLoading(false);
    }
  }

  // 外部用サービス編集
  const [editDataDetailService, setEditDataDetailService] =
    useState<EditDataDifine | null>(null);
  async function putEditDataDetailService() {
    if (editDataDetailService !== null) {
      setIsLoading(true);
      setEditDataDetailService({
        ...editDataDetailService,
        status: "editing",
      });
      const putResponce = await putOutsideEntryFormService(
        editDataDetailService,
      );
      if (putResponce == "success") {
        await getSubtableDataService();
        await getSubtableDataDetailService();
      }
      setEditDataDetailService({
        ...editDataDetailService,
        status: putResponce,
      });
      setIsLoading(false);
    }
  }

  // 外部用サービス新規登録
  const addDataColumnsService =
    outsideEntryFormTableColumn.subTable[2].subDataColumn.reduce(
      (column, difine) => {
        if (difine.add) {
          if (difine.addType === "date") {
            return {
              ...column,
              [difine.key + "_year"]: thisYear.toString(),
              [difine.key + "_month"]: thisMonth.toString(),
              [difine.key + "_date"]: "1",
            };
          } else {
            return {
              ...column,
              [difine.key]: "",
            };
          }
        } else {
          return {
            ...column,
          };
        }
      },
      {},
    );
  const [addDataService, setAddDataService] = useState<{
    [key: string]: string | boolean | any[];
  }>(addDataColumnsService);
  const [onDataAddModalService, setOnDataAddModalService] = useState(false);
  async function openModalSubtableDataAddService() {
    let _addDataService = addDataService;
    outsideEntryFormTableColumn.subTable[2].subDataColumn.map((difine) => {
      if (difine.add && getSubTableAdd.row) {
        if (difine.addType === "tableId") {
          _addDataService[difine.key] = getSubTableAdd.row.id.toString();
        } else if (difine.addType === "tableSubId") {
          _addDataService[difine.key] =
            getSubTableAdd.row[difine.key].toString();
        } else if (difine.addType === "tableData") {
          _addDataService[difine.key] = getSubTableAdd.row[
            difine.key
          ] as string;
        }
      }
    });
    setAddDataService(_addDataService);
    if (getSubTableAdd.row) {
      setOnDataAddModalService(true);
    }
  }
  async function postAddDataService() {
    setIsLoading(true);
    setOnDataAddModalService(false);
    const postResponce = await postOutsideEntryFormService(addDataService);
    if (postResponce === "success") {
      await getTableData(true);
      if (getSubTableName.name == "外部用サービス一覧") {
        await getSubtableDataService();
      }
      setAddDataService(addDataColumnsService);
      setOnSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalService(true);
      setOnSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // Serviceの削除
  const [deleteServiceInf, setDeleteServiceInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    name: string;
    message: string;
  }>({
    status: null,
    name: "",
    key: {},
    message: "",
  });
  async function deleteServiceFunc() {
    setDeleteServiceInf({
      ...deleteServiceInf,
      status: "loading",
    });
    const id = deleteServiceInf.key.id;
    const responce = await deleteOutsideEntryFormService(id);
    if (responce == "success") {
      await getTableData(false);
      await getSubtableDataService();
      setDeleteServiceInf({
        ...deleteServiceInf,
        status: "success",
      });
    } else {
      setDeleteServiceInf({
        ...deleteServiceInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (deleteServiceInf.status === "loading") {
      setIsLoading(true);
    } else if (deleteServiceInf.status !== null) {
      setIsLoading(false);
    }
  }, [deleteServiceInf]);

  // データの削除
  const [deleteDataInf, setDeleteDataInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }>({
    status: null,
    key: {},
    message: "",
  });
  async function deleteData() {
    setDeleteDataInf({
      ...deleteDataInf,
      status: "loading",
    });
    const id = deleteDataInf.key.id;
    const responce = await deleteOutsideEntryForm(id);
    if (responce == "success") {
      await getTableData(false);
      setDeleteDataInf({
        ...deleteDataInf,
        status: "success",
      });
    } else {
      setDeleteDataInf({
        ...deleteDataInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (deleteDataInf.status === "loading") {
      setIsLoading(true);
    } else if (deleteDataInf.status !== null) {
      setIsLoading(false);
    }
  }, [deleteDataInf]);

  // サブサブテーブルデータの登録結果（共通）
  const [onSubSubtableDataAddModalResult, setOnSubSubtableDataAddModalResult] =
    useState("");

  // 外部エントリーフォーム - 外部サービス - 内部サービス紐づけ一覧取得
  async function getSubSubtableDataInsideService() {
    if (getSubSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getOutsideEntryFormServiceInsideServices(
        getSubSubTableName.key.id,
      );
      setGetSubSubTableName({
        ...getSubSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // 外部エントリーフォーム - 外部サービス - 内部サービス紐づけ登録
  const [addDataInsideService, setAddDataInsideService] = useState<{
    [key: string]: string | boolean | any[];
  }>({
    outside_entry_form_service_id: "",
    all_service: [],
    select_service: [],
  });
  const [onDataAddModalInsideService, setOnDataAddModalInsideService] =
    useState(false);
  async function openModalSubSubtableDataAddInsideService() {
    if (getSubSubTableAdd.row) {
      setIsLoading(true);
      const fetchData = await getOutsideEntryFormServiceInsideServices(
        getSubSubTableAdd.row.id as string,
      );
      setAddDataInsideService({
        outside_entry_form_service_id: getSubSubTableAdd.row.id as string,
        all_service: fetchData.serviceDatas,
        select_service: fetchData.sudDatas,
      });
      setOnDataAddModalInsideService(true);
      setIsLoading(false);
    }
  }
  async function postAddDataInsideService() {
    setIsLoading(true);
    setOnDataAddModalInsideService(false);
    const postResponce =
      await postOutsideEntryFormServiceInsideServices(addDataInsideService);
    if (postResponce === "success") {
      if (getSubSubTableName.name == "内部サービス紐づけ一覧") {
        await getSubSubtableDataInsideService();
      }
      setIsLoading(true);
      await getSubtableDataService();
      setAddDataInsideService({
        outside_entry_form_service_id: "",
        all_service: [],
        select_service: [],
      });
      setOnSubSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalInsideService(true);
      setOnSubSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // 上位店一覧
  const [highRankCompanyList, setHighRankCompanyList] = useState<
    { id: number; high_rank_company_name: string }[]
  >([]);
  const [highRankCompanyNameList, setHighRankCompanyNameList] = useState([""]);
  // 上位店一覧取得
  async function getHighRankCompanyList() {
    const fetchData = await getSerchHighRankCompanys();
    if (fetchData === null) {
      setHighRankCompanyList([]);
    } else if (fetchData) {
      setHighRankCompanyList(
        fetchData.highRankCompanys as {
          id: number;
          high_rank_company_name: string;
        }[],
      );
      let highRankCompanyNameList = [""];
      fetchData.highRankCompanys.map(
        (company: { id: number; high_rank_company_name: string }) => {
          if (
            !highRankCompanyNameList.includes(company.high_rank_company_name)
          ) {
            highRankCompanyNameList.push(company.high_rank_company_name);
          }
        },
      );
      setHighRankCompanyNameList(highRankCompanyNameList);
    }
  }

  // カテゴリ一覧
  const [categoryList, setCategoryList] = useState<
    { id: number; category_name: string }[]
  >([]);
  const [categoryNameList, setCategoryNameList] = useState([""]);
  async function getCategoryList() {
    const fetchData = await getSerchCategorys();
    if (fetchData === null) {
      setCategoryList([]);
    } else if (fetchData) {
      setCategoryList(
        fetchData.categorys as {
          id: number;
          category_name: string;
        }[],
      );
      let categoryNameList = [""];
      fetchData.categorys.map(
        (company: { id: number; category_name: string }) => {
          if (!categoryNameList.includes(company.category_name)) {
            categoryNameList.push(company.category_name);
          }
        },
      );
      setCategoryNameList(categoryNameList);
    }
  }

  // 商材一覧
  const [productList, setProductList] = useState<
    { id: number; high_rank_company_id: number; product_name: string }[]
  >([]);
  const [productNameList, setProductNameList] = useState([""]);
  async function getProductList() {
    const fetchData = await getSerchProducts();
    if (fetchData === null) {
      setProductList([]);
    } else if (fetchData) {
      setProductList(
        fetchData.products as {
          id: number;
          high_rank_company_id: number;
          product_name: string;
        }[],
      );
      let productNameList = [""];
      fetchData.products.map(
        (company: {
          id: number;
          high_rank_company_id: number;
          product_name: string;
        }) => {
          if (!productNameList.includes(company.product_name)) {
            productNameList.push(company.product_name);
          }
        },
      );
      setProductNameList(productNameList);
    }
  }
  // 新規登録時、選択した上位店により商材一覧
  const [selectProductList, setSelectProductList] = useState<
    { id: number; high_rank_company_id: number; product_name: string }[]
  >([]);
  useEffect(() => {
    let selectProductList: {
      id: number;
      high_rank_company_id: number;
      product_name: string;
    }[] = [];
    const high_rank_company_id = Number(
      addOutsideEntryForm.high_rank_company_id,
    );
    productList.map((product) => {
      if (product.high_rank_company_id === high_rank_company_id) {
        selectProductList.push(product);
      }
    });
    setSelectProductList(selectProductList);
  }, [addOutsideEntryForm]);

  // 外部エントリーサイトパス一覧
  const [sitePathList, setSitePathList] = useState<
    { id: number; product_id: number; site_path: string }[]
  >([]);
  const [sitePathNameList, setSitePathNameList] = useState([""]);
  async function getSitePathList() {
    const fetchData = await getSerchSitePaths();
    if (fetchData === null) {
      setSitePathList([]);
    } else if (fetchData) {
      setSitePathList(
        fetchData.sitePaths as {
          id: number;
          product_id: number;
          site_path: string;
        }[],
      );
      let sitePathNameList = [""];
      fetchData.sitePaths.map(
        (sitePath: { id: number; product_id: number; site_path: string }) => {
          if (!sitePathNameList.includes(sitePath.site_path)) {
            sitePathNameList.push(sitePath.site_path);
          }
        },
      );
      setSitePathNameList(sitePathNameList);
    }
  }
  // 新規登録時、選択した商材によりサイトパス一覧
  const [selectSitePathList, setSelectSitePathList] = useState<
    { id: number; product_id: number; site_path: string }[]
  >([]);
  useEffect(() => {
    let selectSitePathList: {
      id: number;
      product_id: number;
      site_path: string;
    }[] = [];
    const product_id = Number(addOutsideEntryForm.product_id);
    sitePathList.map((sitePath) => {
      if (sitePath.product_id === product_id) {
        selectSitePathList.push(sitePath);
      }
    });
    setSelectSitePathList(selectSitePathList);
  }, [addOutsideEntryForm]);

  // パートナー一覧
  const [companyList, setCampanyList] = useState<
    { id: number; sale_company_name: string }[]
  >([]);
  const [outsideEntryFormCompanyList, setOutsideEntryFormCompanyList] =
    useState<{ id: number; sale_company_name: string }[]>([]);
  const [companyNameList, setCampanyNameList] = useState([""]);
  // パートナー一覧取得
  async function getSaleCompanysList() {
    const fetchData = await getSerchSaleCompanys();
    if (fetchData === null) {
      setCampanyList([]);
    } else if (fetchData) {
      setCampanyList(
        fetchData.saleCompanys as { id: number; sale_company_name: string }[],
      );
      setOutsideEntryFormCompanyList([
        { id: 0, sale_company_name: "デフォルト" },
        ...(fetchData.saleCompanys as {
          id: number;
          sale_company_name: string;
        }[]),
      ]);
      let companyNameList = ["", "デフォルト"];
      fetchData.saleCompanys.map(
        (company: { id: number; sale_company_name: string }) => {
          if (!companyNameList.includes(company.sale_company_name)) {
            companyNameList.push(company.sale_company_name);
          }
        },
      );
      setCampanyNameList(companyNameList);
    }
  }

  useEffect(() => {
    getHighRankCompanyList();
    getCategoryList();
    getProductList();
    getSaleCompanysList();
    getSitePathList();
  }, []);

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
      data-testid="outside-entry-form-page"
    >
      <PageTabs group="forms" />
      <Box
        sx={{
          display: "flex",
          gap: "var(--sp-2, 8px)",
          alignItems: "stretch",
          flex: 1,
          minHeight: 0,
        }}
      >
        {detailView && dataDetail ? (
          <Box sx={{ flex: 1, minWidth: 0, overflowY: "auto", minHeight: 0 }}>
            <Box data-testid="detail-header" sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <IconButton
                size="small"
                onClick={closeDetailView}
                aria-label="一覧に戻る"
                sx={{ mr: 0.5 }}
              >
                <ArrowBackIcon fontSize="small" />
              </IconButton>
              <Typography
                variant="h6"
                sx={{ fontWeight: 700, fontSize: 20, color: "text.primary" }}
              >
                {String(dataDetail["high_rank_company_name"] ?? "") +
                  " / " +
                  String(dataDetail["product_name"] ?? "")}
              </Typography>
            </Box>
            <DataDetailTable
              editAuth={outsideEntryFormTableColumn.editAuth}
              dataColumn={outsideEntryFormTableColumn.dataColumn}
              subDataColumn={[]}
              dataDetail={dataDetail}
              setEditData={setEditData}
              dataDetailOption={[]}
              dataDetailOptionSelect={[]}
              dataDetailHistory={[]}
              detailTitle={outsideEntryFormTableColumn.detailTitle}
              getGroupList={() => {}}
              setSelectServiseInfo={() => {}}
              setSelectTossUpInfo={() => {}}
            />
          </Box>
        ) : getSubTableDetail.dataDetail !== null ? (
          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
              minHeight: 0,
              maxHeight: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mb: 2,
                flexShrink: 0,
              }}
            >
              <IconButton
                size="small"
                onClick={() => {
                  setDataDetailChatApp(null);
                  setGetSubTableDetail({ name: "", key: {}, dataDetail: null });
                }}
                aria-label="一覧に戻る"
                sx={{ mr: 0.5 }}
              >
                <ArrowBackIcon fontSize="small" />
              </IconButton>
              <Typography
                variant="h6"
                sx={{ fontWeight: 700, fontSize: 20, color: "text.primary" }}
              >
                {getSubTableDetail.name}
              </Typography>
            </Box>
            {getSubTableDetail.name ===
              outsideEntryFormTableColumn.subTable[1].subTableDetailTitle && (
              <DataDetailTable
                detailTitle={
                  outsideEntryFormTableColumn.subTable[1].subTableDetailTitle
                }
                editAuth={outsideEntryFormTableColumn.editAuth}
                dataColumn={[]}
                subDataColumn={
                  outsideEntryFormTableColumn.subTable[1].subDataColumn
                }
                dataDetail={getSubTableDetail.dataDetail}
                setEditData={setEditChatAppData}
                dataDetailOption={[]}
                dataDetailOptionSelect={[]}
                dataDetailHistory={[]}
                getGroupList={() => {}}
                setSelectServiseInfo={() => {}}
                setSelectTossUpInfo={() => {}}
              />
            )}
            {getSubTableDetail.name ===
              outsideEntryFormTableColumn.subTable[3].subTableDetailTitle && (
              <DataDetailTable
                detailTitle={
                  outsideEntryFormTableColumn.subTable[3].subTableDetailTitle
                }
                editAuth={outsideEntryFormTableColumn.subTable[3].subTableEditAuth}
                dataColumn={[]}
                subDataColumn={
                  outsideEntryFormTableColumn.subTable[3].subDataColumn
                }
                dataDetail={getSubTableDetail.dataDetail}
                setEditData={setEditDataDetailSMS}
                dataDetailOption={[]}
                dataDetailOptionSelect={[]}
                dataDetailHistory={[]}
                getGroupList={() => {}}
                setSelectServiseInfo={() => {}}
                setSelectTossUpInfo={() => {}}
              />
            )}
            {getSubTableDetail.name ===
              outsideEntryFormTableColumn.subTable[4].subTableDetailTitle && (
              <DataDetailTable
                detailTitle={
                  outsideEntryFormTableColumn.subTable[4].subTableDetailTitle
                }
                editAuth={outsideEntryFormTableColumn.subTable[4].subTableEditAuth}
                dataColumn={[]}
                subDataColumn={
                  outsideEntryFormTableColumn.subTable[4].subDataColumn
                }
                dataDetail={getSubTableDetail.dataDetail}
                setEditData={setEditDataDetailCancellSMS}
                dataDetailOption={[]}
                dataDetailOptionSelect={[]}
                dataDetailHistory={[]}
                getGroupList={() => {}}
                setSelectServiseInfo={() => {}}
                setSelectTossUpInfo={() => {}}
              />
            )}
            {getSubTableDetail.name ===
              outsideEntryFormTableColumn.subTable[2].subTableDetailTitle && (
              <DataDetailTable
                detailTitle={
                  outsideEntryFormTableColumn.subTable[2].subTableDetailTitle
                }
                editAuth={outsideEntryFormTableColumn.subTable[2].subTableEditAuth}
                dataColumn={[]}
                subDataColumn={
                  outsideEntryFormTableColumn.subTable[2].subDataColumn
                }
                dataDetail={getSubTableDetail.dataDetail}
                setEditData={setEditDataDetailService}
                dataDetailOption={[]}
                dataDetailOptionSelect={[]}
                dataDetailHistory={[]}
                getGroupList={() => {}}
                setSelectServiseInfo={() => {}}
                setSelectTossUpInfo={() => {}}
              />
            )}
          </Box>
        ) : (
          <>
            {(serchOpen || aiChatOpen) && isSmartPhone ? null : (
              <Box
                sx={{
                  flex: 1,
                  minWidth: 0,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <TableTopBar
                  serch={true}
                  serchOpen={serchOpen}
                  setSerchOpen={handleSetSerchOpen}
                  addDataNames={addDataNames}
                  addDataName={addDataName}
                  setAddDataName={setAddDataName}
                  addCSVDataNames={addCSVDataNames}
                  addCSVDataName={addCSVDataName}
                  setAddCSVDataName={setAddCSVDataName}
                  getXLSXDataNames={getXLSXDataNames}
                  getXLSXDataName={getXLSXDataName}
                  setGetXLSXDataName={setGetXLSXDataName}
                  editDatasNames={editDatasNames}
                  editDatasName={editDatasName}
                  setEditDatasName={setEditDatasName}
                  editIDs={editFormsStatus.editIDs}
                  columnSettingOpen={false}
                  openColumnSettingWindow={() => {}}
                    totalCount={totalCount}
                  onReload={() => getTableData(false)}
                />
                <ConstTable
                  getTableData={getTableData}
                  tableType={"main"}
                  serch={true}
                  setSerchOpen={handleSetSerchOpen}
                  serchOpen={serchOpen}
                  tableColumn={outsideEntryFormTableColumn}
                  dataColumn={[]}
                  rows={fetchData}
                  displayNumber={displayNumber}
                  setDisplayNumber={setDisplayNumber}
                  displayNumbers={displayNumbers}
                  pageNumber={pageNumber}
                  setPageNumber={setPageNumber}
                  maxPageNumber={maxPageNumber}
                  totalCount={totalCount}
                  getDataDetail={getDataDetail}
                  getSubTableName={getSubTableName}
                  setGetSubTableName={setGetSubTableName}
                  getSubTableDetail={getSubTableDetail}
                  setGetSubTableDetail={setGetSubTableDetail}
                  setGetSubTableAdd={setGetSubTableAdd}
                  setGetSubTableEditDirect={openQuestionEditDirect}
                  getSubSubTableName={getSubSubTableName}
                  setGetSubSubTableName={setGetSubSubTableName}
                  getSubSubTableDetail={getSubSubTableDetail}
                  setGetSubSubTableDetail={setGetSubSubTableDetail}
                  setGetSubSubTableAdd={setGetSubSubTableAdd}
                  setGetSubSubTableEditDirect={() => {}}
                  tableTitle={outsideEntryFormTableColumn.title}
                  switchTableCheckBox={() => {}}
                  allCheckFlg={false}
                  switchAllTableCheckBox={() => {}}
                  editIDs={editFormsStatus.editIDs}
                  setEditIDs={(editIDs: number[]) => {
                    setEditFormsStatus({
                      ...editFormsStatus,
                      editIDs,
                    });
                  }}
                  setEditDatasName={setEditDatasName}
                  setTableOriginalFunc={setTableOriginalFunc}
                  sortColumn={[]}
                  setSortColumn={() => {}}
                />
              </Box>
            )}
            {serchOpen ? (
              <SerchSideBar
                setSerchOpen={handleSetSerchOpen}
                tableColumn={outsideEntryFormTableColumn}
                dataColumn={[]}
                firstYear={firstYear}
                thisYear={thisYear}
                serchColumn={serchColumn}
                setSerchString={setSerchString}
                companyNameList={companyNameList}
                companyGroupNameList={[]}
                highRankCompanyNameList={highRankCompanyNameList}
                categoryNameList={[]}
                productNameList={productNameList}
                accountSaleNameList={[]}
                accountStaffNameList={[]}
                serchStringView={serchStringView}
                setSerchStringView={setSerchStringView}
              />
            ) : null}
          </>
        )}
      </Box>
      <DataEditModal
        onModal={editData !== null && editData.status !== "editing"}
        swCloseModal={() => setEditData(null)}
        editData={editData}
        setEditData={setEditData}
        putEditData={putEditData}
        groupList={[]}
        categoryList={[]}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <DataAddModal
        onModal={onOutsideEntryFormAddModal}
        swCloseModal={() => {
          setOutsideEntryFormAddModal(false);
          setAddDataName("");
        }}
        addTitle={outsideEntryFormTableColumn.addTitle}
        dataColumn={outsideEntryFormTableColumn.dataColumn}
        subDataColumn={[]}
        postAddData={postAddOutsideEntryForm}
        addData={addOutsideEntryForm}
        setAddData={setAddOutsideEntryForm}
        companyList={outsideEntryFormCompanyList}
        highRankCompanyList={highRankCompanyList}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={selectProductList}
        categoryList={categoryList}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={selectSitePathList}
      />
      <DataEditModal
        onModal={
          editChatAppData !== null && editChatAppData.status !== "editing"
        }
        swCloseModal={() => setEditChatAppData(null)}
        editData={editChatAppData}
        setEditData={setEditChatAppData}
        putEditData={putEditChatAppData}
        groupList={[]}
        categoryList={[]}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <DataAddModal
        onModal={onChatAppAddModal}
        swCloseModal={() => {
          setChatAppAddModal(false);
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={"チャットアプリ連携追加"}
        dataColumn={[]}
        subDataColumn={outsideEntryFormTableColumn.subTable[1].subDataColumn}
        postAddData={postAddChatApp}
        addData={addChatApp}
        setAddData={setAddChatApp}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModalResult
        onModal={onChatAppAddModalResult !== ""}
        swCloseModal={() => {
          setOnChatAppAddModalResult("");
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addModalTitle={"チャットアプリ連携追加"}
        onDataAddModalResult={onChatAppAddModalResult}
      />
      <DataDeleteModal
        onModal={
          deleteChatAppInf.status !== null &&
          deleteChatAppInf.status !== "loading"
        }
        swCloseModal={() => {
          setDeleteChatAppInf({
            status: null,
            key: {},
            message: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        deleteDataInf={deleteChatAppInf}
        setDeleteDataInf={setDeleteChatAppInf}
        deleteData={deleteChatAppData}
        labels={{
          title: "チャットアプリ連携削除",
          confirmBody: (
            <Alert severity="error">
              チャットアプリ連携削除後、データは復元できません。
            </Alert>
          ),
          confirmButtonLabel: "チャットアプリ連携削除",
          successMessage: "チャットアプリ連携の削除に成功しました。",
        }}
      />
      {/* チャット連携-依存質問-選択肢 追加 */}
      <DataAddModal
        onModal={onChatAppDependSelectAddModal}
        swCloseModal={() => {
          setOnChatAppDependSelectAddModal(false);
          setAddChatAppDependSelect({
            outside_entry_form_chat_app_id: "",
            option_id: "",
            outside_option_select_id: "",
          });
          setGetSubSubTableAdd({ name: "", row: null });
        }}
        addTitle={
          outsideEntryFormTableColumn.subTable[1].subTable[0].subTableAddTitle
        }
        dataColumn={[]}
        subDataColumn={chatAppDependSelectAddSubDataColumn}
        postAddData={postAddChatAppDependSelect}
        addData={addChatAppDependSelect}
        setAddData={
          ((updater) => {
            setAddChatAppDependSelect((prev) => {
              const next = (
                typeof updater === "function" ? updater({ ...prev }) : updater
              ) as {
                outside_entry_form_chat_app_id: string;
                option_id: string;
                outside_option_select_id: string;
              };
              if (
                next.option_id !== undefined &&
                next.option_id !== prev.option_id
              ) {
                return { ...next, outside_option_select_id: "" };
              }
              return next;
            });
          }) as Dispatch<
            SetStateAction<{ [key: string]: string | boolean | any[] }>
          >
        }
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
        subDataColumnOptionList={{
          option_id: outsideEntryFormOptionsForChatAppDependFull.map((o) => ({
            id: o.option_id,
            name: o.option_name,
          })),
        }}
        subDataColumnOptionListByKey={(key, addData) => {
          if (key !== "outside_option_select_id") return undefined;
          const opt = outsideEntryFormOptionsForChatAppDependFull.find(
            (o) => String(o.option_id) === String(addData.option_id),
          );
          return opt
            ? opt.option_selects.map((s) => ({
                id: s.id,
                name: s.option_select,
              }))
            : [];
        }}
      />
      <DataAddModalResult
        onModal={onChatAppDependSelectAddModalResult !== ""}
        swCloseModal={() => {
          setOnChatAppDependSelectAddModalResult("");
          setGetSubSubTableAdd({ name: "", row: null });
        }}
        addModalTitle={
          outsideEntryFormTableColumn.subTable[1].subTable[0].subTableAddTitle
        }
        onDataAddModalResult={onChatAppDependSelectAddModalResult}
      />
      {/* チャット連携-依存質問-選択肢 削除 */}
      <DataDeleteModal
        onModal={
          deleteChatAppDependSelectInf.status !== null &&
          deleteChatAppDependSelectInf.status !== "loading"
        }
        swCloseModal={() => {
          setDeleteChatAppDependSelectInf({
            status: null,
            key: {},
            message: "",
          });
          setTableOriginalFunc({ name: "", key: {} });
        }}
        deleteDataInf={deleteChatAppDependSelectInf}
        setDeleteDataInf={setDeleteChatAppDependSelectInf}
        deleteData={async () => {
          setDeleteChatAppDependSelectInf({
            ...deleteChatAppDependSelectInf,
            status: "loading",
          });
          setIsLoading(true);
          try {
            const id = deleteChatAppDependSelectInf.key.id;
            const res = await deleteOutsideEntryFormChatAppDependSelect(id);
            if (res === "success") {
              getSubSubtableDataOutsideEntryFormChatAppDependSelect();
              getSubtableDataChatApp();
              setDeleteChatAppDependSelectInf({
                status: "success",
                key: {},
                message: "",
              });
            } else {
              setDeleteChatAppDependSelectInf({
                status: "failed",
                key: {},
                message: res || "",
              });
            }
          } finally {
            setIsLoading(false);
          }
        }}
        labels={{
          title: "依存質問-選択肢削除",
          confirmBody: (
            <Alert severity="error">削除後、データは復元できません。</Alert>
          ),
          confirmButtonLabel: "削除",
          successMessage: "削除に成功しました。",
        }}
      />
      <DataAddModal
        onModal={onDataAddModalEntryGroup}
        swCloseModal={() => {
          setOnDataAddModalEntryGroup(false);
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={outsideEntryFormTableColumn.subTable[0].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={outsideEntryFormTableColumn.subTable[0].subDataColumn}
        postAddData={postAddDataEntryGroup}
        addData={addDataEntryGroup}
        setAddData={setAddDataEntryGroup}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModalResult
        onModal={onDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnDataAddModalResult("");
          setAddDataName("");
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onDataAddModalResult}
      />
      <DataEditModal
        onModal={
          editDataDetailSMS !== null && editDataDetailSMS.status !== "editing"
        }
        swCloseModal={() => setEditDataDetailSMS(null)}
        editData={editDataDetailSMS}
        setEditData={setEditDataDetailSMS}
        putEditData={putEditDataDetailSMS}
        groupList={[]}
        categoryList={[]}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <DataAddModal
        onModal={onDataAddModalSMS}
        swCloseModal={() => {
          setOnDataAddModalSMS(false);
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={outsideEntryFormTableColumn.subTable[3].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={outsideEntryFormTableColumn.subTable[3].subDataColumn}
        postAddData={postAddDataSMS}
        addData={addDataSMS}
        setAddData={setAddDataSMS}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={selectProductList}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DeletePaymentModal
        onModal={
          deleteSMSInf.status !== null && deleteSMSInf.status !== "loading"
        }
        swCloseModal={() => {
          setDeleteSMSInf({
            status: null,
            name: "",
            key: {},
            message: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        deletePaymentInf={deleteSMSInf}
        setDeletePaymentInf={setDeleteSMSInf}
        deletePayment={deleteSMSFunc}
      />
      <DataAddModal
        onModal={onDataAddModalCancellSMS}
        swCloseModal={() => {
          setOnDataAddModalCancellSMS(false);
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={outsideEntryFormTableColumn.subTable[4].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={outsideEntryFormTableColumn.subTable[4].subDataColumn}
        postAddData={postAddDataCancellSMS}
        addData={addDataCancellSMS}
        setAddData={setAddDataCancellSMS}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={selectProductList}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DeletePaymentModal
        onModal={
          deleteCancellSMSInf.status !== null &&
          deleteCancellSMSInf.status !== "loading"
        }
        swCloseModal={() => {
          setDeleteCancellSMSInf({
            status: null,
            name: "",
            key: {},
            message: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        deletePaymentInf={deleteCancellSMSInf}
        setDeletePaymentInf={setDeleteCancellSMSInf}
        deletePayment={deleteCancellSMSFunc}
      />
      <DataEditModal
        onModal={
          editDataDetailCancellSMS !== null &&
          editDataDetailCancellSMS.status !== "editing"
        }
        swCloseModal={() => setEditDataDetailCancellSMS(null)}
        editData={editDataDetailCancellSMS}
        setEditData={setEditDataDetailCancellSMS}
        putEditData={putEditDataDetailCancellSMS}
        groupList={[]}
        categoryList={[]}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <DataEditModal
        onModal={
          editDataDetailService !== null &&
          editDataDetailService.status !== "editing"
        }
        swCloseModal={() => setEditDataDetailService(null)}
        editData={editDataDetailService}
        setEditData={setEditDataDetailService}
        putEditData={putEditDataDetailService}
        groupList={[]}
        categoryList={[]}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <DataAddModal
        onModal={onDataAddModalService}
        swCloseModal={() => {
          setOnDataAddModalService(false);
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={outsideEntryFormTableColumn.subTable[2].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={outsideEntryFormTableColumn.subTable[2].subDataColumn}
        postAddData={postAddDataService}
        addData={addDataService}
        setAddData={setAddDataService}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={selectProductList}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DeletePaymentModal
        onModal={
          deleteServiceInf.status !== null &&
          deleteServiceInf.status !== "loading"
        }
        swCloseModal={() => {
          setDeleteServiceInf({
            status: null,
            name: "",
            key: {},
            message: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        deletePaymentInf={deleteServiceInf}
        setDeletePaymentInf={setDeleteServiceInf}
        deletePayment={deleteServiceFunc}
      />
      <DataAddModalResult
        onModal={onSubSubtableDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnSubSubtableDataAddModalResult("");
          setGetSubSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onSubSubtableDataAddModalResult}
      />
      <DataAddModal
        onModal={onDataAddModalInsideService}
        swCloseModal={() => {
          setOnDataAddModalInsideService(false);
          setGetSubSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={
          outsideEntryFormTableColumn.subTable[2].subTable[0].subTableAddTitle
        }
        dataColumn={[]}
        subDataColumn={
          outsideEntryFormTableColumn.subTable[2].subTable[0].subDataColumn
        }
        postAddData={postAddDataInsideService}
        addData={addDataInsideService}
        setAddData={setAddDataInsideService}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <ProductEditModal
        onModal={
          editOutsideEntryFormOption !== null &&
          editOutsideEntryFormOption.status !== "editing"
        }
        swCloseModal={() => {
          setEditOutsideEntryFormOption(null);
          setGetSubTableAdd({ name: "", row: null });
        }}
        editProduct={editOutsideEntryFormOption}
        setEditProduct={setEditOutsideEntryFormOption}
        putEditProduct={putEditOutsideEntryFormOption}
        editProductOptionPlans={[]}
        editProductOptionContents={[]}
        editTossUpFormOptionProducts={[]}
        editOutsideServices={editOutsideServices}
        formTitle="外部ETフォーム - 質問一覧編集"
        formType="outside_entry_form"
      />
      <DataAddModalResult
        onModal={onSubtableDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnSubtableDataAddModalResult("");
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onSubtableDataAddModalResult}
      />
      <PostCSVModal
        onModal={
          postOutsideEntryFormOptionCSVStatus.status !== "none"
        }
        swCloseModal={() => {
          setPostOutsideEntryFormOptionCSVStatus({
            status: "none",
            message: "",
            result: [],
            header_location: "None",
          });
          setAddCSVDataName("");
        }}
        postCSVStatus={postOutsideEntryFormOptionCSVStatus}
        setPostCSVStatus={setPostOutsideEntryFormOptionCSVStatus}
        postCSVFunc={postProductsCSV}
        postCSVTitle={"外部ETフォーム - 質問登録CSV取込"}
        postCSVColumn={postCSVColumnOutsideEntryFormOption}
        postCSVColumnResult={postCSVColumnOutsideEntryFormOptionResult}
        postCSVPath="outsideEntryFormOption"
        productList={[]}
        categoryList={[]}
      />
      <DataDeleteModal
        onModal={
          deleteDataInf.status !== null && deleteDataInf.status !== "loading"
        }
        swCloseModal={() => {
          setDeleteDataInf({
            status: null,
            key: {},
            message: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        deleteDataInf={deleteDataInf}
        setDeleteDataInf={setDeleteDataInf}
        deleteData={deleteData}
        labels={{
          title: "外部ETフォーム削除",
          confirmBody: (
            <Alert severity="error">
              外部ETフォーム削除後、データは復元できません。
            </Alert>
          ),
          confirmButtonLabel: "外部ETフォーム削除",
          successMessage: "外部ETフォームの削除に成功しました。",
        }}
      />
      <FormOptionsEditModal
        onModal={
          editFormsStatus.status !== "none" &&
          editFormsStatus.status !== "loading"
        }
        swCloseModal={() => {
          setEditFormsStatus({
            status: "none",
            message: "",
            editIDs: [],
            action: null,
            delete_option_names: [],
            select_option: {
              option_name: "",
              outside_form_display: 0,
              sns_send: 1,
              required_optional: 0,
              option_type: 0,
              option_default_value: "",
              change_value_conf: 0,
              option_comment: "",
              tel_flg: 0,
              name_flg: 0,
              company_name_flg: 0,
              zip_code_flg: 0,
              address_flg: 0,
              space_flg: 0,
              mail_address_flg: 0,
              form_tel_flg: 0,
              multi_text_flg: 0,
              contract_number_flg: 0,
              half_width_number_flg: 0,
              option_select: [""],
            },
          });
          setEditFormOptionNames([]);
          setEditDatasName("");
        }}
        backSwCloseModal={() => {
          setEditFormsStatus({
            ...editFormsStatus,
            status: "none",
            message: "",
            action: null,
          });
          setEditFormOptionNames([]);
          setEditDatasName("");
        }}
        editFormsStatus={editFormsStatus}
        setEditFormsStatus={setEditFormsStatus}
        getEditFormDeleteOptionNames={getEditFormDeleteOptionNames}
        editFormOptionNames={editFormOptionNames}
        postEditFormOption={postEditFormOption}
        deleteEditFormOption={deleteEditFormOption}
        formType="outside_entry_form"
      />
    </Box>
  );
}

export default OutsideEntryForm;
